import { getIcon, Loader } from '@ohif/ui';
import React, { useState, useEffect } from 'react';
import { AppDispatch, RootState } from '@custom/store/store';
import { useDispatch, useSelector } from 'react-redux';
import { customStyle } from '@custom/Utils/utils';
import { useTheme } from '../../../ui/src/contextProviders';
import { editHospitalCaseCredit } from '@custom/rtk-apis/Setting/creditForCaseToCase/updateHospitalCaseCredit';
import { clearEditHospitalCaseCreditState } from '@custom/store/slices/Setting/creditForCaseToCase/updateHospitalCaseCreditSlice';
import { servicesManager } from '../../../app/src/App';
import { getHospitalCaseCredits } from '@custom/rtk-apis/Setting/creditForCaseToCase/getHospitalCaseCredit';
import { getCaseCredits } from '@custom/rtk-apis/Setting/creditForCaseToCase/getCaseCredits';

const EditCaseToCaseForHospital = ({ setShowEditForm, priceModalityData, setTableData, onUpdate, hospitalId, hospitalData }) => {
  const isDarkMode = useTheme();
  const dispatch = useDispatch<AppDispatch>();
  const { uiNotificationService } = servicesManager?.services;

  const editHospitalCaseCreditSliceResponse = useSelector(
    (state: RootState) => state?.editHospitalCaseCreditResponse
  );
  const hospitalIdForCredit = hospitalData?._id;

  const [credit, setCredit] = useState(priceModalityData?.credit || '');
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (priceModalityData) {
      setCredit(priceModalityData.credit || '');
    }
  }, [priceModalityData]);

  useEffect(() => {
    if (editHospitalCaseCreditSliceResponse?.status === 'SUCCESS' && editHospitalCaseCreditSliceResponse?.result) {
      const updatedItem = editHospitalCaseCreditSliceResponse.result;
      setTableData((prev) =>
        prev.map((item) => (item._id === updatedItem._id ? updatedItem : item))
      );
      if (onUpdate) {
        onUpdate(updatedItem);
      }
      setTimeout(() => {
        setShowEditForm(false);
      }, 1000);
      setIsLoading(false);
    } else if (editHospitalCaseCreditSliceResponse?.status === 'FAILED' || editHospitalCaseCreditSliceResponse?.status === 'ERROR') {
      uiNotificationService.show({
        title: 'Update modality credit',
        message: editHospitalCaseCreditSliceResponse?.msg || editHospitalCaseCreditSliceResponse?.error || 'Something went wrong...',
        type: 'error',
      });
      setIsLoading(false);
      dispatch(clearEditHospitalCaseCreditState());
    }
  }, [editHospitalCaseCreditSliceResponse?.status, editHospitalCaseCreditSliceResponse?.result, editHospitalCaseCreditSliceResponse?.error]);

  const handleUpdate = async () => {
    setIsLoading(true);
    try {
      if (!hospitalId || !priceModalityData?._id || !credit || isNaN(parseFloat(credit)) || parseFloat(credit) < 0) {
        uiNotificationService.show({
          title: 'Error',
          message: 'Please provide a valid hospital ID, modality data, and a non-negative credit value.',
          type: 'error',
        });
        return;
      }
      const payload = {
        hospitalId,
        telecreditId: priceModalityData._id,
        credit: parseFloat(credit),
        modality: priceModalityData.modality,
      };
      await dispatch(editHospitalCaseCredit(payload)).unwrap();
      await dispatch(getHospitalCaseCredits({ hospitalId: hospitalIdForCredit }));
      await dispatch(getCaseCredits());
    } catch (error) {
      uiNotificationService.show({
        title: 'Error',
        message: 'Failed to update credits. Please try again.',
        type: 'error',
      });
    } finally {
      setIsLoading(false);
      setTimeout(() => {  
        setShowEditForm(false);
      }, 1000);
    }
  };

  const cancel = () => {
    setShowEditForm(false);
  };

  return (
    <div
      className="page page__full"
      style={isDarkMode?.isDarkMode ? { background: '#090c29' } : customStyle.mainBackground}
    >
      <div className="page__body">
        <div className="details">
          <div className="form form--innersec">
            <div className="mb-3">
              <button
                className=""
                onClick={cancel}
                style={{ display: 'flex', alignItems: 'center' }}
              >
                {getIcon('icon-toolbar-back')}
                Back
              </button>
            </div>
            <section className="form__section">
              <h1 className="form__section__title">Credits For Case-To-Case Setting</h1>
              <div className="formRow formRow__2">
                <div className="formCol">
                  <div className="form__Field">
                    <label className="form__label" htmlFor="modality">
                      Modality
                    </label>
                    <input
                      className="form__input form__input--sm"
                      id="modality"
                      value={priceModalityData?.modality || ''}
                      disabled
                    />
                  </div>
                </div>
                <div className="formCol">
                  <div className="form__Field">
                    <label className="form__label" htmlFor="credits">
                      Credits
                      <span className="required-asterisk">*</span>
                    </label>
                    <input
                      className="form__input form__input--sm"
                      type="number"
                      min="0"
                      id="credit"
                      value={credit}
                      onChange={(e) => setCredit(e.target.value)}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>

              <div className="btn__group">
                <button className="btn btn__white" onClick={cancel}>
                  Cancel
                </button>
                <button className="btn btn__primary" onClick={handleUpdate} disabled={isLoading}>
                  Update
                </button>
              </div>
            </section>
          </div>
        </div>
      </div>
      <Loader isLoaderOpen={isLoading || editHospitalCaseCreditSliceResponse?.loading} />
    </div>
  );
};

export default EditCaseToCaseForHospital;
